import { cn } from "@garther/ui/libs";
import * as React from "react";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  labelClassName?: string;
  error?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, labelClassName, required, error, ...props }, ref) => {
    return (
      <div>
        {label && (
          <div className={cn("text-text-secondary font-medium text-responsive-sm", labelClassName)}>
            {label} {required && <span className="text-red-500">(*)</span>}
          </div>
        )}
        <textarea
          ref={ref}
          className={cn(
            "w-full rounded-sm border border-border-light bg-transparent px-3 py-2 text-sm font-normal text-text-primary",
            "placeholder:text-text-secondary",
            "focus:outline-none focus:border-border-dark",
            "disabled:cursor-not-allowed disabled:opacity-50",
            "resize-none min-h-[80px]",
            error && "border-red-200",
            className
          )}
          {...props}
        />
        {error && <p className="text-responsive-sm text-red-400">{error}</p>}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
